export default __webpack_public_path__ + "static/media/a011-startup-06.5646543f.svg";